import { IonImg, useIonViewWillLeave, IonRippleEffect, IonAvatar, IonNote, IonText, IonGrid, IonCol, IonRow, IonProgressBar, IonIcon, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { RouteComponentProps } from "react-router-dom";
import { playCircleSharp, pauseSharp, heart } from 'ionicons/icons';

// import Swiper core and required modules
import SwiperCore, { Virtual, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement, handleRouteError } from "../components/NServer";
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { hideTab, showTab } from "../components/Tabs";
import ContentWrapper from "../components/ContentWrapper";
import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CreateContentInfo, ContentDetail, CountNum } from '../data/item';
import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 

import './Main.css'; 

interface VideoProp extends RouteComponentProps<{
    id : string,
    mode : string
    }> 
{}

// install Virtual module
SwiperCore.use([Virtual, Navigation]);

var curContentID = -1;

const Videos : React.FC<VideoProp> = ({match}) => {

    const [contentID, setContentID] = useState(-1);
    const [swiperRef, setSwiperRef] = useState<any>(null);
    const [content, setContent] = useState<ContentInfo>(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));

    const [nextID, setNextID] = useState(-1);
    const [prevID, setPrevID] = useState(-1);
    const [nextImage, setNextImage] = useState("");
    const [prevImage, setPrevImage] = useState("");
    const [nextVideo, setNextVideo] = useState("");
    const [prevVideo, setPrevVideo] = useState("");
    const [showHelp, setShowHelp] = useState(false);

    const curVidRef = useRef<any>();
    const prevVidRef = useRef<any>();
    const nextVidRef = useRef<any>();

    const vidRefList = useRef<any[]>([]);
    const [vidList, setVidList] = useState<string[]>([]);
    const [contentList, setContentList] = useState<number[]>([]);
    const [thumbnails, setThumbnails] = useState<string[]>([]);

    const [curIndex, setCurIndex] = useState(0);
    const [pausedVid, setPauseVid] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        curContentID = parseInt(match.params.id);

        showVideoHelp();

        getData();
        hideTab();
    });

    useIonViewWillLeave(() => {
        showTab();

        // stop playing videos
        for (var i = 0; i < vidRefList.current.length; i++)
        {
            if (vidRefList.current[i] != null)
            {
                vidRefList.current[i].pause();
            }
        }
    });

    // need to refresh
    useEffect(() => {
        curContentID = contentID;
    },[contentID]);

    // show the video help if applicable
    const showVideoHelp = async () => {
        let firstTime = await FirstTime("video");
        setShowHelp(firstTime);
    }

    // reload the data
    const getData = async (c : number = -1, dir : number = 0) => {
        // upload the content
        let v = new Vault();
        await v.read();

        var cindex = "" + c;
        if (c < 0)
            cindex = match.params.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: cindex
        }

        var server = new NServer();
        await server.getList("nc_content_video", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setContentID(server.data.content.id);
            setContent(server.data.content);

            setNextID(server.data.next_id);
            setNextImage(server.data.next_img);
            setPrevID(server.data.prev_id);
            setPrevImage(server.data.prev_img);
            setNextVideo(server.data.next_video);
            setPrevImage(server.data.prev_video);

            if (dir == 0)
            {
                setContentList([server.data.prev_id, server.data.content.id, server.data.next_id]);
                setVidList([server.data.prev_video, server.data.cur_video, server.data.next_video]);
                setThumbnails([server.data.prev_img, server.data.content.thumbnail, server.data.next_img]);
            }
            if (dir > 0)
            {
                if (swiperRef != null)
                {
                    if (swiperRef.realIndex == vidList.length-1)
                    {
                        let videos = vidList.concat([server.data.next_video]);
                        setVidList(videos);

                        let contents = contentList.concat([server.data.next_id]);
                        setContentList(contents);

                        let thumb = thumbnails.concat([server.data.next_img]);
                        setThumbnails(thumb);
                    }
                }
            }
        }
    }

    // update the content
    const onUpdateContent = (index : number, c : any, local : boolean) => {
        if (c.id != curContentID && curContentID > 0)
            return;

        if (local)
        {
            // copy content
            let newContent = JSON.parse(JSON.stringify(c));
            setContent(newContent);
        }
        else
        {
            getData(c.id, -1);    // currently -1 disable video reload
        }
    }

    // close the UI
    const closeUI = () => {
    }

    // swipe event
    const changeSwipe = () => {
        if (swiperRef != null)
        {
            if (curIndex != swiperRef.realIndex)
            {
                // stop last video
                if (vidRefList.current[curIndex] != null)
                {
                    if (!vidRefList.current[curIndex].paused)
                        vidRefList.current[curIndex].pause();                    
                }
            }

            // play next video
            if (vidRefList.current[swiperRef.realIndex] != null)
            {
                if (vidRefList.current[swiperRef.realIndex].paused)
                    vidRefList.current[swiperRef.realIndex].play();
            }

            // load new data
            if (curIndex != swiperRef.realIndex)
            {
                var dir = curIndex < swiperRef.realIndex ? 1 : -1;
                var c = contentList[swiperRef.realIndex];
                getData(c, dir);

                setContentID(-1);
            }
            
            setPauseVid(false);
            setCurIndex(swiperRef.realIndex);
            //DEL console.log("Current index: " + swiperRef.realIndex + ", Total videos: " + vidList.length);
        }
    }

    // pause or play the video
    const pausePlay = (index : number) => {
        if (vidRefList.current[index] != null)
        {
            if (vidRefList.current[index].paused)
            {
                vidRefList.current[index].play();
                setPauseVid(false);
            }
            else
            {
                vidRefList.current[index].pause();
                setPauseVid(true);
            }
        }
    }

    // set the video reference
    const setVidRef = (index : number, el : any) => {
        let cur = 1;
        if (swiperRef != null)
            cur = swiperRef.realIndex;

        if (vidRefList.current[index] != null && el == null && index != cur && index != cur-1 && index != cur+1)
            vidRefList.current[index].src = "";

        vidRefList.current[index] = el;

        // if (vidRefList.current[index] != null && index == cur+1)
        //s   console.log("reload: " + index) ; //vidRefList.current[index].load();
    }

    return (
        <IonPage>
            <IonContent className="video-bk" fullscreen>
                {
                    content.id < 0 ?
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonBackButton text="" defaultHref="/mainc" ></IonBackButton>
                            </IonButtons>
                        </IonToolbar>
                    </IonRow>
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol className="center-white-text" size-md="8" size-lg="6" size-xl="4" size="10">
                            <div></div>
                            <div><IonText><h4>{ GetStr(LANGUAGE.TXT_CONTENT_404_CAP) }</h4></IonText></div>
                            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
                            <div><IonText>{ GetStr(LANGUAGE.TXT_CONTENT_404_DESC) }</IonText></div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                    :
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                            <div className="video-content">
                                {
                                    contentID >= 0 ?
                                <div>
                                    { /* user info bar */ }
                                    <UserBar content={content} index={contentID} onUpdate={onUpdateContent} view="video" autoplay={true} />
                                    { /* like bar */ }
                                    <LikeBar content={content} index={contentID} onUpdate={onUpdateContent} view="video" autoplay={true} />
                                </div>
                                    :
                                <div/>
                                }

                                <Swiper
                                    className="fullscreen-swiper"
                                    onSwiper={setSwiperRef}
                                    direction={"vertical"}
                                    slidesPerView={1}
                                    initialSlide={1}
                                    spaceBetween={0}
                                    onTransitionEnd={changeSwipe}
                                >
                                    {
                                        vidList.map( (m, index) => (
                                    
                                    <SwiperSlide className="fullscreen-swipe-item" key={index}>
                                        {
                                            m == "" ?
                                        <div className="fullscreen-video-error">
                                            <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                                        </div>
                                            :
                                            (index == curIndex-1 || index == curIndex || index == curIndex+1) ?
                                        <video ref={el => setVidRef(index, el) } 
                                            className="fullscreen-video-player" 
                                            loop={true}  controls
                                            controlsList="nodownload noplaybackrate foobar"
                                            preload="auto"
                                            onClick={ ()=> pausePlay(index) }
                                            poster={ thumbnails[index] }
                                        >
                                            <source src={ m } />
                                            Your browser does not support the video tag.
                                        </video>
                                            :
                                        <div className="fullscreen-thumb-wrapper">
                                            <IonImg ref={ el => setVidRef(index, null) }
                                                className="fullscreen-thumb-player" src={thumbnails[index]} />
                                        </div>
                                        }
                                        {/* 
                                            :
                                        <video ref={el => vidRefList.current[index] = el} 
                                            className="fullscreen-video-player" 
                                            loop={true}  
                                            onClick={ ()=> pausePlay(index) }
                                            poster={ thumbnails[index] }
                                        >
                                            <source src={ m } />
                                            Your browser does not support the video tag.
                                        </video>
                                        }
                                        */}
                                        {
                                            /* paused video 
                                            pausedVid ?
                                        <div className="pause-video-icon" onClick={ ()=> pausePlay(index) }>
                                            <IonIcon className="pause-icon" icon={playCircleSharp} />
                                        </div>
                                            :
                                        <div/>
                                        */
                                        }
                                    </SwiperSlide>
                                    ))}

                                    {/* 
                                    <SwiperSlide className="fullscreen-swipe-item" key={0}>
                                        <div className="fullscreen-video-wrapper">
                                            {
                                                prevID < 0 ?
                                            <div className="center-white-text">{ GetStr(LANGUAGE.TXT_VID_NOMORE_VIDEO) }</div>
                                                :
                                            <div>
                                                { // <img className="fullscreen-video-player" src={prevImage} />  }
                                                <video id="prev-vid" ref={prevVidRef} className="fullscreen-video-player" preload="auto">
                                                    <source src={ prevVideo } />
                                                    Your browser does not support the video tag.
                                                </video>                                            
                                            </div>
                                            }
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="fullscreen-swipe-item" key={2}>
                                        <div className="fullscreen-video-wrapper">
                                            {
                                                nextID < 0 ?
                                            <div className="center-white-text">{ GetStr(LANGUAGE.TXT_VID_NOMORE_VIDEO) }</div>
                                                :
                                            <div>
                                                { // <img className="fullscreen-video-player" src={nextImage} />  }
                                                <video ref={el => vidRefList.current[2] = el} className="fullscreen-video-player" preload="auto">
                                                    <source src={ nextVideo } />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                            }
                                        </div>
                                    </SwiperSlide>
                                */}
                                </Swiper>
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                }
                {
                    /* help info */
                    showHelp ?
                <div className="info-pane" onClick={ ()=> setShowHelp(false) }>
                    <div className="info-pane-top">
                        <div><img className="updown-obj" src="/assets/img/swipe_up.png" /></div>
                        { GetStr(LANGUAGE.TXT_VIDEO_SWIPE_UP) }
                    </div>
                    <div className="info-pane-bottom">
                        { GetStr(LANGUAGE.TXT_VIDEO_SWIPE_DOWN) }
                        <br/><br/><br/>
                        <div><img className="updown-obj" src="/assets/img/swipe_down.png" /></div>
                    </div>
                </div>
                    :
                <div/>
                }
            </IonContent>
        </IonPage>
    );
};

export default Videos;